import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import { postData, getData } from '../../config/api-connect';
import {
  Table, Select, DatePicker, Spin, Input, Breadcrumb,
  Empty, Button, message, Modal, Tag, Upload
} from 'antd';
import {
  HomeOutlined, BankFilled, EditOutlined, CheckCircleOutlined,
  EyeOutlined, PlusOutlined, UploadOutlined,
} from '@ant-design/icons';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import { toProperCase } from '../../utils/stringUtil.js'
import { getDropdownFilter, getSearchFilter } from '../../utils/filterHelper.jsx'

import { getLocationOrigin } from '../../config/api-connect';

const { Option } = Select;

const UnverifiedCollections = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  let venue_id = queryParams.get('venue_id');
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  var local_city = JSON.parse(localStorage.getItem('cityId'))

  let local_selectedVenueId = venue_id;
  if (!venue_id) {
    local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  }

  const [loading, setLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)

  const cityId = local_city
  const selectedVenueId = local_selectedVenueId

  const [collectionData, setCollectionData] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState([])
  const [selectedCollectionID, setSelectedCollectionID] = useState(null)
  const [selectedTransactionID, setSelectedTransactionID] = useState('')

  const [phonePeLoader, setPhonePeLoader] = useState(false)
  const [phonePeEntries, setPhonePeEntries] = useState([])

  const [attachmentModalVisible, setAttachmentModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);

  const inputRef = useRef(null);

  const [paymentModes, setPaymentModes] = useState({});
  const [paymentModeModalVisible, setPaymentModeModalVisible] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState('');

  useEffect(() => {
    getData('/eagleeye/get_payment_modes/')
      .then(response => {
        if (response?.payment_modes) {
          setPaymentModes(response.payment_modes);
        }
      })
      .catch(error => {
        console.log('Failed to fetch payment modes:', error.message);
      });
  }, []);

  useEffect(() => {
    if (isModalVisible) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100); // delay because of animation
    }
  }, [isModalVisible]);

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    if (cityId !== '') {
      setLoading(true)
      getUnverifiedCollections()
    }
  }, [month, year]);

  const getUnverifiedCollections = () => {
    setLoading(true)
    getData(`/business/get_unverified_collections/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
      .then(response => {
        setCollectionData(response.results);
      })
      .catch(error => {
        console.log(error.message);
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const sampleData = collectionData[0] || {};
  const excludedkeysfordownload = ['id', 'Attachment']

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const handleFormSubmit = async () => {
    setIsSaving(true);
    try {
      const transactionID = selectedTransactionID;

      const response = await postData('/finance/update_transaction_id/', {
        'collection_id': selectedCollectionID,
        'transaction_id': transactionID
      });
      if (response.success) {
        message.success(response.message);
        setIsModalVisible(false);
        getUnverifiedCollections();
      } else {
        message.error(response.message);
      }
    } catch (errorInfo) {
      message.error('Operation Failed. Try again');
    } finally {
      setIsSaving(false);
    }
  };

  const openPaymentModeModal = (record) => {
    setSelectedCollection(record);
    setSelectedPaymentMode(record.payment__mode);
    setPaymentModeModalVisible(true);
  };

  const handlePaymentModeClose = () => {
    setPaymentModeModalVisible(false);
    setSelectedCollection([]);
    setSelectedPaymentMode('');
  };

  const handlePaymentModeSubmit = async () => {
    try {
      const response = await postData('/finance/update_payment_mode/', {
        collection_id: selectedCollection?.id,
        payment_mode: selectedPaymentMode,
      });
      if (response.success) {
        message.success(response.message);
        handlePaymentModeClose();
        getUnverifiedCollections();
      } else {
        message.error(response.message);
      }
    } catch (errorInfo) {
      message.error('Operation Failed. Try again');
    }
  };

  const openActionModal = (collectionID, transactionID, selectedRow) => {
    setIsModalVisible(true)
    setSelectedCollection(selectedRow)
    setSelectedCollectionID(collectionID)
    setSelectedTransactionID(transactionID)

    if (selectedRow.payment__mode === 'phonepe') {
      fetchPhonePeEntries(collectionID, transactionID)
    }

  }

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedCollection([])
    setSelectedCollectionID(null);
    setSelectedTransactionID('');
  };

  const getPhonePePayments = () => {
    fetchPhonePeEntries(selectedCollection.id, selectedTransactionID)
  }

  const fetchPhonePeEntries = (collectionID, transactionID) => {
    setPhonePeLoader(true)

    getData(`/finance/get_matching_payment_entries/?collection_id=${collectionID}&transaction_id=${transactionID}`)
      .then(response => {
        setPhonePeEntries(response.matching_entries);
      })
      .catch(error => {
        console.log(error.message);
      })
      .finally(() => {
        setPhonePeLoader(false)
      })
  }

  const highlightMatch = (text, highlight) => {
    if (!highlight) return text;

    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const highlightAmount = (value, selectedAmount) => {
    if (Number(value) === Number(selectedAmount))
      return (
        <span style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
          {value.toLocaleString("en-IN")}
        </span>
      );

    return value.toLocaleString("en-IN");
  };

  const highlightDate = (collectedDate, paidAt) => {
    if (!collectedDate || !paidAt) return collectedDate;

    const collectedDatePart = collectedDate.split(" ")[0];
    const paidAtDatePart = paidAt.split(" ")[0];

    if (collectedDatePart === paidAtDatePart) {
      return (
        <span>
          <span style={{ backgroundColor: "#ffeb3b", padding: "0 2px" }}>
            {collectedDatePart}
          </span>
          {" " + collectedDate.split(" ").slice(1).join(" ")}
        </span>
      );
    }

    return collectedDate;
  };

  const phonePeColumns = [
    {
      title: "Collected Date",
      dataIndex: "collected_date",
      render: (value) => highlightDate(value, selectedCollection.PaidDate),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (value) => highlightAmount(value, selectedCollection.Amount),
      align: "right",
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      render: (value) => highlightMatch(value, selectedTransactionID),
    },
    {
      title: "UTR",
      dataIndex: "transaction_utr",
      render: (value) => highlightMatch(value, selectedTransactionID),
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
    },
    {
      title: "",
      render: (_, record) =>
        record.is_processed ? (
          <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 18 }} />
        ) : (
          <Button
            size="small"
            type="default"
            style={{
              color: "#1890ff",
              borderColor: "#1890ff",
            }}
            onClick={() =>
              confirmPhonePeVerify(selectedCollection.id, record.id)
            }
          >
            Verify
          </Button>
        ),
    }
  ]

  const confirmPhonePeVerify = (collection_id, phonepe_id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Do you want to continue verifying this PhonePe collection?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        verifyPhonepeCollection(collection_id, phonepe_id);
      },
    });
  };

  const verifyPhonepeCollection = (collection_id, phonepe_id) => {
    postData('/finance/verify_phonepe_payment/', { 'collection_id': collection_id, 'transaction_id': selectedTransactionID, 'phonepe_id': phonepe_id })
      .then(response => {
        handleModalClose()
        if (response.success) {
          getUnverifiedCollections()
          Modal.success({
            content: response.message,
          });
        }
        else {
          Modal.error({
            content: response.message,
          });
        }
      })
      .catch(error => {
        console.log(error.message);
      });
  }

  const renderHeader = (title) => {
    return (
      <div style={{ textAlign: 'center', fontWeight: 'bold', textWrap: 'nowrap' }}>{title}</div>
    )
  }

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const getAmountSorter = (dataIndex) => ({
    sorter: (a, b) => a[dataIndex] - b[dataIndex],
  });

  const openAttachmentModal = (record) => {
    setSelectedRecord(record);
    setFileList([]);
    setAttachmentModalVisible(true);
  };

  const handleClose = () => {
    setAttachmentModalVisible(false);
    setSelectedRecord(null);
    setFileList([]);
  }

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };

  const handleUpload = async () => {
    setUploadLoading(true);
    if (fileList.length === 0) {
      message.warning('Please select a file before uploading!');
      return;
    }

    const file = fileList[0].originFileObj;

    try {
      const data = await uploadFileToAPI(file);
      message.success(data.message || 'File uploaded successfully!');
      handleClose();
    } catch (error) {
      message.error(error.message || 'Something went wrong!');
    } finally {
      setUploadLoading(false);
      getUnverifiedCollections();
    }
  };

  const uploadFileToAPI = async (file) => {
    const formData = new FormData();
    formData.append("collection_id", selectedRecord.id);
    formData.append("screenshot", file);

    const url = `${getLocationOrigin()}/finance/update_payment_screenshot/`;
    const options = {
      method: 'POST',
      body: formData,
      credentials: 'include',
    };

    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Upload failed');
    return response.json();
  };

  const styles = {
    primary: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "18px",
    },

    secondary: {
      color: "#6b7280",
      fontSize: 12,
      lineHeight: "16px",
    },
  };

  const columns = [
    {
      title: renderHeader("Paid Date"),
      dataIndex: "PaidDate",
      render: (value) => {
        if (!value) return "-";

        const [date, time, meridian] = value.split(" ");

        return (
          <>
            <div style={styles.primary}>{date}</div>
            <div style={styles.secondary}>
              {time} {meridian}
            </div>
          </>
        );
      },
      ...getDateSorter("PaidDate"),
    },

    {
      title: renderHeader("Customer"),
      key: "Customer",
      align: "left",
      render: (_, record) => (
        <>
          <div style={styles.primary}>
            {record["customer__name"]}
          </div>

          <div style={styles.secondary}>
            {record.Mobile}
          </div>
        </>
      ),
      ...getSearchFilter("Mobile", "Mobile"),
    },

    {
      title: renderHeader("Venue"),
      key: "VenueDetails",
      align: "left",
      width: 180,
      render: (_, record) => (
        <>
          <div style={styles.primary}>
            {record.Venue}
          </div>

          <div style={styles.secondary}>
            {record.City}
          </div>
        </>
      ),
      ...getDropdownFilter("Venue", collectionData),
    },

    {
      title: renderHeader("Payment Mode"),
      dataIndex: "payment__mode",
      align: "center",
      render: (value, record) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}>
          <span style={{ fontWeight: 500 }}>
            {paymentModes[value] || value}
          </span>
          {Object.keys(paymentModes).includes(value) && (
            <EditOutlined
              onClick={() => openPaymentModeModal(record)}
              style={{ fontSize: "14px", cursor: "pointer", color: "#02475C" }}
              title="Edit Payment Mode"
            />
          )}
        </div>
      ),
      ...getDropdownFilter("payment__mode", collectionData),
    },

    {
      title: renderHeader("Amount"),
      dataIndex: "Amount",
      align: "center",
      render: (value) => (
        <span style={{ fontWeight: 700 }}>
          {Number(value || 0).toLocaleString("en-IN")}
        </span>
      ),
      ...getAmountSorter("Amount"),
    },

    {
      title: renderHeader("Transaction ID"),
      dataIndex: "Transaction_id",
      align: "center",
      render: (value, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 6,
          }}
        >
          {value ? (
            <>
              <span>{value}</span>
              <EditOutlined
                onClick={() => openActionModal(record?.id, value, record)}
                style={{ fontSize: "14px", cursor: "pointer", color: "#02475C" }}
                title="Edit Transaction ID"
              />
            </>
          ) : (
            <Button
              size="small"
              type="default"
              onClick={() => openActionModal(record?.id, value, record)}
              style={{
                borderColor: "#02475C",
                color: "#02475C",
                fontSize: 12,
                padding: "0px 8px",
              }}
            >
              + Add
            </Button>
          )}
        </div>
      ),
      ...getSearchFilter("Transaction_id", "Transaction ID"),
    },

    {
      title: renderHeader("Comment"),
      key: "Comment",
      width: 200,
      align: "left",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 5,
          }}
        >
          <span
            style={{
              fontSize: 12,
              color: '#374151'
            }}
          >
            {record.Comment}
          </span>

          {record.Attachment ? (
            <EyeOutlined
              style={{
                fontSize: 16,
                cursor: "pointer",
                color: "#02475C",
              }}
              onClick={() => openAttachmentModal(record)}
            />
          ) : (
            <PlusOutlined
              style={{
                fontSize: 16,
                cursor: "pointer",
                color: "#9ca3af",
              }}
              onClick={() => openAttachmentModal(record)}
            />
          )}
        </div>
      ),
    },

    {
      title: renderHeader("Collected By"),
      dataIndex: "CollectedBy",
      align: "center",
      render: (value) => (
        <span style={styles.primary}>
          {value || "-"}
        </span>
      ),
      ...getDropdownFilter("CollectedBy", collectionData),
    },

    {
      title: renderHeader("Status"),
      dataIndex: "Status",
      align: "center",
      render: (value) => {
        let color = "#52c41a";

        if (value === "Expired") color = "#ff4d4f";
        else if (value === "Cancelled") color = "#faad14";

        return (
          <Tag
            color={color}
            style={{
              borderRadius: 12,
              fontWeight: 500,
              minWidth: 70,
              textAlign: "center",
            }}
          >
            {value}
          </Tag>
        );
      },
      ...getDropdownFilter("Status", collectionData),
    },

    {
      title: renderHeader("Start Date"),
      key: "SubscriptionPeriod",
      align: "center",
      render: (_, record) => (
        <>
          <div style={styles.primary}>
            {record.StartDate}
          </div>

          <div style={styles.secondary}>
            to {record.EndDate}
          </div>
        </>
      ),
    },

    {
      title: renderHeader("Package"),
      dataIndex: "Package",
      align: "left",
      width: 180,
      render: (value) => (
        <span style={{ fontWeight: 500, fontSize: 13 }}>
          {value}
        </span>
      ),
    },
  ];

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.TopDiv>
          <Breadcrumb style={{ padding: '10px' }} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/collection">
                <BankFilled />
                <span style={{ paddingLeft: '5px' }}>Collection</span>
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <span>Unverified Collections</span>
            </Breadcrumb.Item>

          </Breadcrumb>

          <div style={{ display: 'flex' }}>
            <Styled.Selector>
              <Select
                className='mainSelector'
                style={{ width: 150 }}
                onChange={setMonth}
                value={month}
                bordered={false}
              >
                <Option value="12"> December </Option>
                <Option value="11"> November </Option>
                <Option value="10"> October </Option>
                <Option value="09"> September </Option>
                <Option value="08"> August </Option>
                <Option value="07"> July </Option>
                <Option value="06"> June </Option>
                <Option value="05"> May </Option>
                <Option value="04"> April </Option>
                <Option value="03"> March </Option>
                <Option value="02"> February </Option>
                <Option value="01"> January </Option>
              </Select>
            </Styled.Selector>

            <Styled.Selector>
              <div className='mainSelector'>
                <DatePicker defaultValue={moment(year, 'YYYY')} onChange={onChangeYear} bordered={false} picker="year" />
              </div>
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.NewHeader>
          <span></span>
          <span> Unverified Collections</span>
          {
            <>
              <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="table-for-download"
                filename={'Unverified Collections  ' + moment(month, 'MM').format('MMMM') + ' ' + year}
                sheet={'Unverified Collections'}
                buttonText="Download" />
            </>
          }
        </Styled.NewHeader>
        <div className="recordCount">{collectionData?.length || 0} records</div>
        <div>
          <Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={collectionData}
            pagination={{ pageSize: 50, showSizeChanger: false }}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </Styled.MainContainer>

      <table style={{ display: 'none' }} id="table-for-download">
        <thead>
          <tr>
            {Object.keys(sampleData)
              .filter((head) => !excludedkeysfordownload.includes(head))
              .map((head, index) => (
                <th key={index}>{toProperCase(head)}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {collectionData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(sampleData)
                .filter((key) => !excludedkeysfordownload.includes(key))
                .map((key, colIndex) => {
                  const value = row[key];
                  const isAmount = key.toLowerCase().includes('amount');
                  return (
                    <td key={colIndex}>
                      {isAmount ? formatIndianCurrency(value) : value}
                    </td>
                  );
                })}
            </tr>
          ))}
        </tbody>
      </table>

      <Modal title={selectedTransactionID ? 'Edit Transaction ID' : 'Add Transaction ID'}
        open={isModalVisible}
        closable={true}
        width={selectedCollection.payment__mode === 'phonepe' ? 1000 : 520}
        onCancel={handleModalClose}
        footer={
          selectedCollection.payment__mode === 'phonepe'
            ? null
            : [
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleFormSubmit}
                loading={isSaving}
              >
                Submit
              </Button>,
            ]
        }
      >
        <p style={{ fontSize: 13, color: "#595959", textAlign: 'center' }}>
          {selectedCollection.customer__name && selectedCollection.customer__name + '- '}  {selectedCollection.Mobile} paid{" "}
          <span style={{ fontWeight: 600 }}>
            {selectedCollection.Amount?.toLocaleString("en-IN")}
          </span>{" "}
          at{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection.Venue}</span>{" "}
          on{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection.PaidDate}</span>
        </p>

        {selectedCollection.payment__mode !== 'phonepe' ?
          <Input ref={inputRef} placeholder="enter transaction id" value={selectedTransactionID} onChange={(e) => setSelectedTransactionID(e.target.value)} />
          :
          <>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 20,
              }}
            >
              <div style={{ width: 150, fontWeight: 500 }}>Transaction ID</div>

              <div style={{ display: "flex", gap: 10, flex: 1 }}>
                <Input
                  ref={inputRef}
                  placeholder="Enter transaction ID"
                  value={selectedTransactionID}
                  onChange={(e) => setSelectedTransactionID(e.target.value)}
                />

                <Button
                  type="default"
                  loading={phonePeLoader}
                  onClick={getPhonePePayments}
                >
                  Search
                </Button>

                <Button type="primary" onClick={handleFormSubmit}>
                  Save
                </Button>
              </div>
            </div>


            {phonePeLoader ?
              <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>
                Checking for matching PhonePe payments...
              </p>
              :
              phonePeEntries.length > 0 ?
                <div style={{ maxWidth: "100%", overflowX: "auto" }}>
                  <p style={{ fontSize: 14, fontWeight: 500, marginBottom: 10, color: "#389e0d" }}>
                    Matching PhonePe payments found for this payment
                  </p>

                  <Table
                    dataSource={phonePeEntries}
                    columns={phonePeColumns}
                    size="small"
                    pagination={phonePeEntries.length > 5 ? { pageSize: 5 } : false}
                    bordered
                    rowKey="id"
                  />
                </div>
                :

                <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10, color: "#cf1322" }}>
                  No matching PhonePe payments found for this transaction ID
                </p>
            }
          </>
        }

      </Modal>

      <Modal title="Edit Payment Mode"
        open={paymentModeModalVisible}
        closable={true}
        width={600}
        onCancel={handlePaymentModeClose}
        footer={[
          <Button key="back" onClick={handlePaymentModeClose}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!Object.keys(paymentModes).includes(selectedCollection?.payment__mode) || selectedCollection?.payment__mode === selectedPaymentMode}
            onClick={handlePaymentModeSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <p style={{ fontSize: 13, color: "#595959", textAlign: 'center' }}>
          {selectedCollection?.customer__name && selectedCollection.customer__name + '- '}  {selectedCollection?.Mobile} paid{" "}
          <span style={{ fontWeight: 600 }}>
            {selectedCollection?.Amount?.toLocaleString("en-IN")}
          </span>{" "}
          at{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection?.Venue}</span>{" "}
          on{" "}
          <span style={{ fontWeight: 600 }}>{selectedCollection?.PaidDate}</span>
        </p>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 120, fontWeight: 500 }}>Payment Mode</div>
          <Select
            style={{ flex: 1 }}
            value={selectedPaymentMode}
            onChange={(value) => setSelectedPaymentMode(value)}
            placeholder="Select payment mode"
            disabled={!Object.keys(paymentModes).includes(selectedCollection?.payment__mode)}
          >
            {Object.entries(paymentModes).map(([key, label]) => (
              <Option key={key} value={key}>{label}</Option>
            ))}
          </Select>
        </div>
      </Modal>

      <Modal
        title="Payment Screenshot"
        visible={attachmentModalVisible}
        width={600}
        onCancel={() => handleClose()}
        footer={[
          <Button
            key="cancel"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>,

          <Button
            key="save"
            type="primary"
            loading={uploadLoading}
            disabled={!fileList.length}
            onClick={handleUpload}
          >
            {selectedRecord?.Attachment ? "Update" : "Upload"}
          </Button>,
        ]}
      >
        {selectedRecord?.Attachment ? (
          <div style={{ marginBottom: 20, textAlign: "center" }} >
            <img
              src={selectedRecord.Attachment}
              alt="attachment"
              style={{
                maxWidth: "100%",
                maxHeight: 350,
                objectFit: "contain",
                border: "1px solid #f0f0f0",
                borderRadius: 4,
              }}
            />
          </div>
        ) : (
          <Empty
            description="No attachment uploaded"
            style={{ marginBottom: 20 }}
          />
        )}

        <Upload
          accept="image/*"
          maxCount={1}
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false}
        >
          <Button icon={<UploadOutlined />}>
            {selectedRecord?.Attachment ? "Change Image" : "Select Image"}
          </Button>
        </Upload>
      </Modal>

    </Spin>
  )
}

export default UnverifiedCollections;	